import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { fromEvent, ReplaySubject, Subscription } from 'rxjs';
import { auditTime } from 'rxjs/operators';

@Directive({
  selector: '[appOverflowHide]',
  exportAs: 'inView'
})
export class OverflowHideDirective implements AfterViewInit, OnDestroy {

  private contentDiv: HTMLElement;
  private subscriptions = new Subscription;

  private isInViewSource = new ReplaySubject<boolean>(1);
  public isInView$ = this.isInViewSource.asObservable();

  private checkInView() {

    const element: HTMLElement = this.elementRef.nativeElement;
    const elementRec: ClientRect = element.getBoundingClientRect();
    const contentDivRec: ClientRect = this.contentDiv.getBoundingClientRect();

    const elementRight = elementRec.right;
    const contentDivWidth = contentDivRec.width;

    if (elementRight > 0 && elementRight < contentDivWidth) {
      element.classList.remove('hide');
      this.isInViewSource.next(true);
    } else {
      element.classList.add('hide');
      this.isInViewSource.next(false);
    }
  }

  // Life cycle
  constructor(
    private elementRef: ElementRef,
  ) { }

  ngAfterViewInit() {
    this.contentDiv = document.body;

    setTimeout(() => this.checkInView());
    const resize = fromEvent(window, 'resize').pipe(auditTime(100)).subscribe(() => this.checkInView());

    this.subscriptions.add(resize);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
